import React, { Component } from 'react';
import { connect } from 'react-redux';

import { evAddAddressClick, evAddressesPageView, evDeleteAddress, evMakeShippingOptionPrimary } from 'events/account';
import { firePixelServer } from 'actions/pixelServer';
import { changeShippingAddress, deleteShippingAddress, fetchShippingInfo } from 'actions/account/shipping';
import { checkCustomerAuthentication } from 'actions/authentication';
import { PageLoader } from 'components/Loader';
import AccountHeader from 'containers/account/AccountHeader';
import AccountBreadcrumbs from 'components/account/AccountBreadcrumbs';
import BackNav from 'components/account/BackNav';
import ShippingCardLayout from 'components/account/ShippingCardLayout';
import SiteAwareMetadata from 'components/SiteAwareMetadata';
import { titaniteView, track } from 'apis/amethyst';
import { PAGE_TYPE_MAP } from 'helpers/analytics';
import { cn } from 'helpers/classnames';
import withUseMyAccountRedesignHOC from 'helpers/useMyAccountRedesignHOCWrapper';

import styles from 'styles/containers/account/shipping.scss';

export class Shipping extends Component {
  componentDidMount() {
    titaniteView();

    const {
      firePixelServer,
      checkCustomerAuthentication,
      shipping: { addresses }
    } = this.props;
    const returnTo = '/addresses';

    if (addresses) {
      this.firePageLoadTracking(addresses);
    }

    checkCustomerAuthentication(returnTo, () => this.fetchData(), {
      redirectOnClose: '/'
    });
    firePixelServer('my-account', {}, 'addresses-list');
  }

  componentDidUpdate(prevProps) {
    const {
      shipping: { addresses: prevAddresses }
    } = prevProps;
    const {
      shipping: { addresses }
    } = this.props;

    if (addresses && prevAddresses === null) {
      this.firePageLoadTracking(addresses);
    }
  }

  firePageLoadTracking(addresses) {
    const hasDefaultShippingAddress = addresses.some(address => address.isDefaultShippingAddress);
    track(() => [evAddressesPageView, { numberOfAddresses: addresses.length, hasDefaultShippingAddress }]);
  }

  fetchData() {
    const {
      shipping: { addresses },
      fetchShippingInfo
    } = this.props;

    if (!addresses) {
      fetchShippingInfo(null, '/addresses');
    }
  }

  handleDelete = ({ addressId }, win = window) => {
    const { deleteShippingAddress } = this.props;
    Promise.resolve(deleteShippingAddress(addressId)).then(response => {
      if (response?.results[0]?.addressId) {
        const { addressId } = response.results[0];
        track(() => [evDeleteAddress, { addressId, addressType: 2, sourcePage: PAGE_TYPE_MAP.account }]); // amethyst addressType 2 => shipping
      }
    });
    win.scrollTo(0, 0);
  };

  handleMakePrimary = (item, win = window) => {
    const { changeShippingAddress } = this.props;
    const { addressId } = item;

    const updatedAddress = { ...item, isDefaultShippingAddress: true };
    track(() => [evMakeShippingOptionPrimary, { addressId }]);
    changeShippingAddress(updatedAddress);
    win.scrollTo(0, 0);
  };

  handleAddNewAddress = () => {
    track(() => [evAddAddressClick, { addressType: 2 }]); // amethyst addressType 2 => shipping
  };

  render() {
    const {
      shipping: { addresses, isLoading }
    } = this.props;

    if (!addresses || isLoading) {
      return <PageLoader centered={true} />;
    }

    return (
      <SiteAwareMetadata>
        <div className={cn(styles.shipping, { [styles.adjustMarginAndPaddingNewDesign]: this.props.isMyAccRedesignHookValue })}>
          <div className={styles.header}>
            <AccountBreadcrumbs
              currentText="Shipping Information"
              homeLinkName={this.props.isMyAccRedesignHookValue ? 'Account' : 'Account Overview'}
            />
            <BackNav to="/account">My Account</BackNav>
            <AccountHeader title="Shipping Information" />
          </div>
          <ShippingCardLayout
            addresses={addresses}
            onPrimary={this.handleMakePrimary}
            onDelete={this.handleDelete}
            onAddNewAddress={this.handleAddNewAddress}
          />
        </div>
      </SiteAwareMetadata>
    );
  }
}

const mapStateToProps = state => ({
  shipping: state.shipping
});

export default connect(mapStateToProps, {
  fetchShippingInfo,
  deleteShippingAddress,
  changeShippingAddress,
  firePixelServer,
  checkCustomerAuthentication
})(withUseMyAccountRedesignHOC(Shipping, 'isMyAccRedesignHookValue'));
